//  Cart Auto-Refresh
(() => {
  let isRefreshing = false;
  let refreshTimeout = null;

  const handleCartChange = () => {
    if (isRefreshing) return;
    clearTimeout(refreshTimeout);
    isRefreshing = true;
    
    refreshTimeout = setTimeout(() => {
      dispatchCustomEvent('cart-drawer:refresh');
      setTimeout(() => {
        isRefreshing = false;
        refreshTimeout = null;
      }, 500);
    }, 1000);
  };

  document.addEventListener('cart-drawer:item-added', handleCartChange);
  document.addEventListener('cart-drawer:item-removed', handleCartChange);
})();